import { defineStore } from "pinia";
import { StoreModule } from "@/constants/store";

export interface ErrorPayload {
  message: string;
  showDialog?: boolean;
  index?: number;
  field?: string;
  customErrorHandling?: boolean;
  errors?: ErrorPayload[];
}

export interface ErrorsState {
  errors: Array<ErrorPayload>;
}

const defaultErrorsState: ErrorsState = {
  errors: [],
};

export const useErrorsStore = defineStore(StoreModule.ERRORS, {
  state: (): ErrorsState => ({ ...defaultErrorsState }),
  persist: false,
  getters: {
    error(state) {
      return state.errors.length > 0 ? state.errors[state.errors.length - 1] : null;
    },
  },
  actions: {
    push(error: ErrorPayload) {
      this.errors = [...this.errors, error];
    },
    pop() {
      this.errors = this.errors.slice(0, -1);
    },
  },
});
